import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 18"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9 17c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM9 2C5.14 2 2 5.14 2 9s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9 10.72c.36 0 .56-.34.59-.92l.35-4.34c0-.61-.42-1.1-.94-1.1s-.94.5-.94 1.12l.35 4.35c.03.62.22.89.59.89z"
    }, null, -1),
    _createElementVNode("circle", {
      fill: "currentColor",
      cx: "9",
      cy: "12.66",
      r: ".79"
    }, null, -1)
  ])))
}
export default { render };